import {DiagnosticReportId} from '@legit.health/ui';
import {UserId} from '@legit.health/ui';
import {DomainEvent} from '@/shared/contexts/EventDispatcherContext';

export const CONDITION_ASSIGNED_TO_DIAGNOSTIC_REPORT =
  'diagnosticReport.condition_diagnosticReport';

type Payload = {
  diagnosticReportId: DiagnosticReportId;
  patientId: UserId;
};

export type ConditionAssignedToDiagnosticReportEvent = DomainEvent & Payload;

export function createConditionAssignedToDiagnosticReportEvent(
  props: Payload
): ConditionAssignedToDiagnosticReportEvent {
  return Object.freeze({
    name: CONDITION_ASSIGNED_TO_DIAGNOSTIC_REPORT,
    ...props
  });
}
